<!-- Floating launcher — bottom right, on every admin screen -->
<button
  type="button"
  class="atlas-launcher"
  [class.is-open]="open()"
  [attr.aria-expanded]="open()"
  aria-label="Ask Atlas"
  (click)="toggle()"
>
  <i class="ti" [ngClass]="open() ? 'ti-x' : 'ti-sparkles'"></i>
  @if (!open()) {
    <span class="atlas-launcher-label">Ask Atlas</span>
  }
</button>

@if (open()) {
  <div class="atlas-window" [class.is-minimized]="minimized()" role="dialog" aria-label="Ask Atlas">
    <div class="atlas-window-head">
      <!-- A real button, so the whole title acts as a large minimise/restore target -->
      <button
        type="button"
        class="atlas-head-title"
        [attr.aria-expanded]="!minimized()"
        [title]="minimized() ? 'Restore' : 'Minimise'"
        (click)="toggleMinimize()"
      >
        <i class="ti ti-sparkles"></i> Ask Atlas
        @if (minimized() && busy()) {
          <span class="atlas-head-pending" aria-label="Still working"></span>
        }
      </button>
      <span class="atlas-head-actions">
        @if (messages().length && !minimized()) {
          <button type="button" class="atlas-head-btn" title="New conversation" (click)="clear()">
            <i class="ti ti-refresh"></i>
          </button>
        }
        <button
          type="button"
          class="atlas-head-btn"
          [title]="minimized() ? 'Restore' : 'Minimise'"
          (click)="toggleMinimize()"
        >
          <i class="ti" [ngClass]="minimized() ? 'ti-chevron-up' : 'ti-minus'"></i>
        </button>
        <button type="button" class="atlas-close" title="Close" (click)="close()">&times;</button>
      </span>
    </div>

    <div class="atlas-panel">
      <div class="atlas-thread" #thread>
        @if (messages().length === 0) {
          <div class="atlas-welcome">
            <div class="atlas-welcome-title">👋 Hi, I'm Atlas</div>
            <div class="atlas-welcome-sub">
              VeloRide's read-only operations &amp; finance assistant. Ask me about the business and I'll answer with the
              numbers behind every answer — I only read data, I never change anything.
            </div>

            <div class="atlas-welcome-heading">What I can help with</div>
            <ul class="atlas-capabilities">
              @for (c of capabilities; track c.text) {
                <li><span>{{ c.icon }}</span> {{ c.text }}</li>
              }
            </ul>

            <div class="atlas-welcome-heading">Try asking</div>
            <div class="atlas-suggestions">
              @for (s of suggestions; track s) {
                <button type="button" class="atlas-suggestion" (click)="send(s)">{{ s }}</button>
              }
            </div>
          </div>
        }

        @for (m of messages(); track $index) {
          <div class="atlas-msg" [ngClass]="'atlas-' + m.role">
            @if (m.role === 'assistant') {
              <!-- Atlas replies in markdown. Plain [innerHTML], so Angular sanitizes it. -->
              <div class="atlas-md" [innerHTML]="m.content | atlasMarkdown"></div>
            } @else {
              {{ m.content }}
            }
          </div>
        }

        @if (busy()) {
          <div class="atlas-msg atlas-assistant atlas-typing" aria-label="Analyzing">
            <span class="atlas-dot"></span><span class="atlas-dot"></span><span class="atlas-dot"></span>
          </div>
        }

        @if (error()) {
          <div class="atlas-error">{{ error() }}</div>
        }
      </div>

      <div class="atlas-input">
        <textarea
          #prompt
          rows="1"
          [(ngModel)]="draft"
          [disabled]="busy()"
          placeholder="Ask about trips, revenue, drivers…"
          title="Enter to send · Shift+Enter for a new line"
          (input)="autoGrow()"
          (keydown.enter)="onEnterKey($event)"
        ></textarea>
        <button
          type="button"
          class="atlas-send"
          aria-label="Send"
          [disabled]="busy() || !draft.trim()"
          (click)="send()"
        >
          <i class="ti ti-send"></i>
        </button>
      </div>
    </div>
  </div>
}
